import { render, staticRenderFns } from "./editorbanben1.vue?vue&type=template&id=44090943&scoped=true"
import script from "./editorbanben1.vue?vue&type=script&lang=js"
export * from "./editorbanben1.vue?vue&type=script&lang=js"
import style0 from "./editorbanben1.vue?vue&type=style&index=0&id=44090943&prod&lang=css"
import style1 from "./editorbanben1.vue?vue&type=style&index=1&id=44090943&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44090943",
  null
  
)

export default component.exports